export default __webpack_public_path__ + "static/media/Gin.9bbbb097.mp3";